export default "__VITE_ASSET__QKtGiOHp__"